export default __webpack_public_path__ + "static/media/great_work.605d6f2a.png";